module.exports = __webpack_public_path__ + "img/contact.8803e048.png";